import React from "react";
import "./Portfolio.css";
import { Grid } from "@mui/material";
import portfolio from "../images/fitandwear.png";
import portfolio2 from "../images/HTML, CSS, JS Conversion 8.png";
import portfolio3 from "../images/HTML, CSS, JS Conversion 6.png";
import portfolio4 from "../images/DIU Blood For life.png";
const Portfolio = () => {
  const portfolio_data = [
    {
      name: "DIU Blood For Life",
      photo: portfolio4,
      liveLink: "https://diu-blood-for-life.netlify.app/",
    },
    {
      name: "Fit and Wear E-commerce",
      photo: portfolio,
      liveLink: "https://fit-and-wear.netlify.app/",
      githubLink:
        "https://github.com/alshadab/E-Commerce---Front-End-Development.git",
    },
    {
      name: "Hotel Booking",
      photo: portfolio2,
      liveLink: "https://fututech-hotel-booking.netlify.app/",
      githubLink: "https://github.com/alshadab/Hotel_Booking.git",
    },
    {
      name: "Food Order",
      photo: portfolio3,
      liveLink: "https://food-order-system.netlify.app/",
      githubLink: "https://github.com/alshadab/Food_Order_System.git",
    },
  ];
  return (
    <div className="BG-portfolio" id="portfolio">
      <div className="container" style={{ paddingBottom: "50px" }}>
        <div className="after">
          <h1>My Portfolio</h1>
        </div>
        <Grid container spacing={2}>
          {portfolio_data.map((data) => {
            return (
              <Grid item xs={12} md={6} lg={4}>
                <div className="portfolio-box">
                  <div className="content-box">
                    <img src={data.photo} alt={data.name} />
                  </div>
                  <h3
                    style={{
                      marginTop: "8px",

                      fontWeight: "bold",
                    }}
                  >
                    {data.name}
                  </h3>

                  <button
                    style={{ marginTop: "8px" }}
                    type="button"
                    class="btn btn-danger"
                  >
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      href={data.liveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Live Link
                    </a>
                  </button>
                  {data.githubLink && (
                    <button
                      style={{ margin: "8px 0 0 8px" }}
                      type="button"
                      class="btn btn-success"
                    >
                      <a
                        style={{ textDecoration: "none", color: "white" }}
                        href={data.githubLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Github Link
                      </a>
                    </button>
                  )}
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default Portfolio;
